{
  "common": {
    "loading": "Cargando...",
    "save": "Guardar",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "back": "Volver",
    "search": "Buscar",
    "viewMore": "Ver más",
    "viewAll": "Ver todo"
  },
  "header": {
    "nav": {
      "brands": "Tiendas",
      "reviews": "Reseñas",
      "causes": "Causas",
      "howItWorks": "Cómo funciona",
      "about": "Sobre nosotros"
    },
    "search": {
      "placeholder": "Buscar tiendas asociadas..."
    },
    "user": {
      "myAccount": "Mi Cuenta",
      "settings": "Configuración",
      "myCause": "Mi Causa",
      "adminPanel": "Panel Admin",
      "logout": "Salir",
      "fallbackName": "Usuario"
    },
    "menu": {
      "myProfile": "Mi Perfil",
      "navigate": "Navegar"
    },
    "auth": {
      "login": "Entrar",
      "register": "Registrarse"
    }
  },
  "footer": {
    "tagline": "Transformando compras en donaciones desde enero de 2025.",
    "sections": {
      "forYou": "Para ti",
      "institutional": "Institucional",
      "contact": "Contacto"
    },
    "links": {
      "howItWorks": "Cómo funciona",
      "partnerStores": "Tiendas Asociadas",
      "causes": "Causas",
      "register": "Regístrate",
      "about": "Sobre Nosotros",
      "howWeGenerate": "Cómo generamos ingresos",
      "partner": "Sé un Socio",
      "privacy": "Privacidad",
      "terms": "Términos de uso",
      "cookies": "Preferencias de cookies",
      "contact": "Habla con nosotros"
    },
    "promovendo": {
      "title": "Generar para Donar",
      "intro": "Cupom Verificado es una iniciativa de",
      "brand": "Promovendo o Bem",
      "body": ", organización sin fines de lucro que practica un verdadero emprendimiento social. Nuestra comisión cubre los costos operativos y",
      "reinvested": "todo excedente se reinvierte en proyectos sociales",
      "cta": "Saber más"
    },
    "rights": "Todos los derechos reservados."
  },
  "hero": {
    "badgeBrands": "{{count}} tiendas asociadas",
    "badgeFallback": "Tiendas asociadas",
    "headlineStart": "",
    "headlineHighlight": "Cashback Solidario",
    "headlineEnd1": " está",
    "headlineEnd2": "en Cupom Verificado",
    "lead": "Donar y ahorrar nunca fue tan fácil.",
    "subheadline": "Compras por el mismo precio en tus tiendas favoritas. La donación ocurre sola.",
    "ctaStart": "Comenzar a donar",
    "ctaCause": "Registra una causa",
    "metricsTitle": "Cupom Verificado en números",
    "sinceLine": "Llevando conciencia al proceso de compra desde",
    "stats": {
      "gmv": "en ventas generadas para marcas",
      "raised": "recaudación confirmada",
      "monitoredProducts": "productos monitoreados",
      "comparableProducts": "productos para comparar",
      "products50Plus": "productos con 50% o más de descuento",
      "activeCoupons": "cupones de descuento activos",
      "users": "Usuarios",
      "brands": "tiendas activas",
      "causes": "causas activas",
      "volunteers": "voluntarios"
    }
  },
  "brand": {
    "viewCoupon": "Ver cupón",
    "goShopping": "Ir de compras",
    "activateDonation": "Activar donación"
  },
  "cookie": {
    "message": "Usamos cookies para mejorar tu experiencia.",
    "accept": "Aceptar",
    "decline": "Rechazar",
    "title": "Tu privacidad",
    "body": "Usamos cookies esenciales y cookies publicitarias (Google AdSense) para sostener la plataforma y mostrar anuncios relevantes. Puedes aceptar o rechazar las cookies de marketing en cualquier momento.",
    "learnMore": "Saber más",
    "ariaLabel": "Aviso de cookies",
    "close": "Cerrar"
  },
  "howItWorks": {
    "title": "Cómo funciona",
    "subtitle": "Pagas el mismo precio. La donación ocurre sola.",
    "closingLead": "El resto de la comisión mantiene la plataforma en marcha. ",
    "closingHighlight": "Lo que sobra también se dona",
    "closingTail": ". Un proyecto 100% social, hecho para generar impacto.",
    "causeCta": "Registra una causa",
    "steps": {
      "register": {
        "title": "Crea tu cuenta",
        "description": "Menos de un minuto para elegir la causa que quieres apoyar."
      },
      "pickStore": {
        "title": "Elige la tienda",
        "description": "390 tiendas asociadas y más de un millón de productos: compras donde ya compras."
      },
      "buy": {
        "title": "Compra como siempre",
        "description": "Haz clic en 'Ir de compras' y finaliza en la tienda. Sin costos extra."
      },
      "donate": {
        "title": "La donación ocurre sola",
        "description": "La tienda nos paga una comisión y parte de ella se convierte en donación para tu causa."
      }
    }
  },
  "brandsCarousel": {
    "title": "Tiendas que hacen la diferencia",
    "subtitleWithCount": "Elige entre nuestras {{count}} tiendas asociadas. Cada compra genera donaciones automáticas para la causa que apoyas.",
    "subtitle": "Cada compra genera donaciones automáticas para la causa que apoyas.",
    "empty": "Ninguna tienda encontrada en esta categoría.",
    "viewAll": "Ver todas las tiendas",
    "error": "No se pudieron cargar las tiendas.",
    "retry": "Reintentar",
    "loading": "Cargando tiendas...",
    "donatesUpTo": "Dona hasta {{value}}"
  },
  "causesShowcase": {
    "title": "Causas que transforman vidas",
    "subtitle": "Elige una organización para apoyar. Tu donación es automática con cada compra que hagas.",
    "viewAll": "Ver todas las causas",
    "loading": "Cargando causas...",
    "error": "No se pudieron cargar las causas.",
    "retry": "Reintentar",
    "empty": "Ninguna causa encontrada por ahora.",
    "viewCause": "Ver Causa",
    "defaultDescription": "Apoya esta causa y transforma vidas.",
    "coverAlt": "Portada de {{name}}"
  }
}
